























import Vue from 'vue';
import { IPartnerShopInformation } from '@/common/interfaces/partnershop.interface';
import ProfileAvatar from '@/components/common/profile-avatar/ProfileAvatar.vue';
import PartnerShopMethods from '../../methods/PartnerShopMethods';
import RinganaMap from '../common/maps/RinganaMap.vue';
import { ICoordinates } from '../../common/interfaces/location.interface';

interface IPartnerMap {
  coordinates: ICoordinates;
  partnerShopInformation: IPartnerShopInformation;
  partnerShopName: string;
}

export default Vue.extend({
  name: `PartnerMap`,
  components: {
    ProfileAvatar,
    RinganaMap,
  },
  data(): IPartnerMap {
    return {
      coordinates: { latitude: 0, longitude: 0 },
      partnerShopInformation: {},
      partnerShopName: window.location.hostname.split(`.`)[0],
    };
  },
  computed: {
    displayFullName(): string {
      if(this.partnerShopInformation) {
        if(this.partnerShopInformation.firstname && this.partnerShopInformation.lastname) {
          return `${this.partnerShopInformation.firstname} ${this.partnerShopInformation.lastname}`;
        }
        if(this.partnerShopInformation.company) {
          return this.partnerShopInformation.company;
        }
      }
      return ``;
    },
    formatAddress(): string {
      let address = ``;
      if(this.partnerShopInformation.address) {
        address += this.partnerShopInformation.address.street ? `${this.partnerShopInformation.address.street} ` : ``;
        address += this.partnerShopInformation.address.streetNumber ? this.partnerShopInformation.address.streetNumber : ``;

        address += (this.partnerShopInformation.address.street && this.partnerShopInformation.address.streetNumber) ? `, ` : ``;

        address += this.partnerShopInformation.address.postalCode ? `${this.partnerShopInformation.address.postalCode} ` : ``;
        address += this.partnerShopInformation.address.city ? this.partnerShopInformation.address.city : ``;

        address += (this.partnerShopInformation.address.postalCode && this.partnerShopInformation.address.city) ? `, ` : ``;

        address += this.partnerShopInformation.address.country ? this.partnerShopInformation.address.country : ``;
      }
      return address;
    },
  },
  async mounted(): Promise<void> {
    await this.fetchPartnerShopInformation();
    window.$swal = this.$swal;
  },
  methods: {
    async fetchPartnerShopInformation(): Promise<void> {
      this.partnerShopInformation = await PartnerShopMethods.getPartnerShopInformation();

      if(this.partnerShopInformation && this.partnerShopInformation.address) {
        const { address } = this.partnerShopInformation;
        if(address.latitude !== undefined && address.longitude !== undefined && !Number.isNaN(+address.latitude) && !Number.isNaN(+address.longitude)) {
          this.coordinates = { latitude: +address.latitude, longitude: +address.longitude };
        } else {
          this.coordinates = await this.$apiService.getCoordinates({
            city: address.city ?? ``,
            country: address.country ?? ``,
            postalCode: address.postalCode ?? ``,
            street: address.street ?? ``,
          });
        }
      }
    },
  },
});
